$(document).ready(function () {
    // if (window.innerWidth > 1023.98) {
    //     window.onscroll = function () {
    //         var prevScrollpos = window.pageYOffset;
    //         filter = document.querySelector('.filters-closed')
    //         window.onscroll = function () {
    //             var currentScrollPos = window.pageYOffset;
    //             let nav = document.querySelector('body .rct_navigation ');
    //             if (prevScrollpos > currentScrollPos || prevScrollpos <= 0) {
    //                 document.getElementById("shopify-section-header").style.display = "block";
    //                 if (filter) {
    //                     filter.classList.remove("filters-closed--top");
    //                 }
    //
    //                 if (nav) {
    //                     document.querySelector("body .rct_navigation ").classList.remove("rct_navigation--top");
    //                 }
    //             } else {
    //                 document.getElementById("shopify-section-header").style.display = "none";
    //                 if (nav) {
    //                     document.querySelector("body .rct_navigation ").classList.add("rct_navigation--top");
    //                 }
    //                 if (filter) {
    //                     filter.classList.add("filters-closed--top");
    //                 }
    //             }
    //             prevScrollpos = currentScrollPos;
    //         };
    //     };
    // }
    $(document).on('click', 'a[href$="pages/booking"]', function (e) {
        e.preventDefault();
        let bookingStoreData = localStorage.getItem('persist:root');
        if (!!bookingStoreData) {
            bookingStoreData = JSON.parse(bookingStoreData)
            if (bookingStoreData?.quizData) {
                let quizDataCopy = JSON.parse(bookingStoreData.quizData)
                quizDataCopy.selected_office = null
                quizDataCopy.category_id = null
                quizDataCopy.service_id = null
                bookingStoreData.quizData = JSON.stringify(quizDataCopy)
            }
        }
        localStorage.setItem('persist:root', JSON.stringify(bookingStoreData));
        window.location.href = $(this).attr('href');

    });
    $('.logoutButtonBooking').click(function (e) {
        e.preventDefault();
        localStorage.removeItem('accountAccessToken');
        localStorage.removeItem('persist:root');

        window.location.href = '/account/logout';
    });

    $('.nav-mobile .mob-location').click(function () {
        $('.nav-mobile .location-dropdown').addClass('d-block');
        $('.menu-icon .close').addClass('d-none');
        $('.nav-mobile .menu-content').removeClass('d-block');
        $('.menu-icon .back').addClass('d-block');
    });

    $('.nav-mobile .mob-search').click(function () {
        $('.nav-mobile .search-wrapper').addClass('d-block');
        $('.nav-mobile .menu-content').removeClass('d-block');
        $('.menu-icon .close').addClass('d-none');
        $('.menu-icon .back').addClass('d-block');
        closeSearchBar();
    });

    function closeSearchBar () {
        $('.mob-opacity').click(function() {
            $('.menu-icon .back').trigger('click');
            $('.menu-icon .close').trigger('click');
        })

    }

    $('.menu-icon .open').click(function () {
        $('.nav-mobile .menu-content').addClass('d-block');
        $('.menu-icon .close').removeClass('d-none');
        $('.mob-opacity').removeClass('d-none');
        $(this).addClass('d-none');
    });

    $('.menu-icon .close').click(function () {
        $('.nav-mobile .menu-content').removeClass('d-block');
        $('.mob-opacity').addClass('d-none');
        $('.menu-icon .open').removeClass('d-none');
        $(this).addClass('d-none');
    });

    $('.menu-icon .back').click(function () {
        $('.nav-mobile article').removeClass('d-block');
        $('.menu-icon .close').removeClass('d-none');
        $(this).removeClass('d-block');
        $('.nav-mobile .menu-content').removeClass('d-none');
        $('.nav-mobile .menu-content').addClass('d-block');
    });

    $('nav .search-link').hover(function () {
        $('.search-inp input').focus();
    });

    $('.newsletter .close').click(function () {
        $('.newsletter').addClass('d-none');
    });

    $('.newsletter-submit').click(function () {
        $(this).addClass('d-none');
        $('.newsletter-inp').addClass('d-none');
        $('.newsletter p').removeClass('d-none');
        $('.newsletter .send-msg').removeClass('d-none');
    });

    $('.cookies .accept').click(function () {
        $('.cookies').addClass('d-none');
    });

    $('.faq-menu li').click(function () {
        $('.faq-menu li').removeClass('active');
        $(this).addClass('active');
        let type = $(this).data('type');
        $('.faq-wrapper').hide();
        $('[data-type=' + type + ']').show();
    });

    if ($('.faq-menu')) {
        $('.faq-menu li').first().click();
    }

    $('.faq-wrapper article .question').click(function () {
        const index = $(this).parent('article').index();
        $(this)
            .closest('.faq-wrapper')
            .find('article .answer')
            .each(function (i) {
                if (i !== index) {
                    $(this).slideUp();
                    $(this).parent('article').find('.question>div').addClass('close');
                }
            });
        $(this).parent('article').find('.question>div').toggleClass('close');
        $(this).parent('article').find('.answer').slideToggle();
    });
    var hasDropdownState;
    $('.has-dropdown').on('mouseenter', function () {
        $('.mob-opacity.d-none').removeClass('d-none');
        if (getYPosition() <= 0) {
            $("nav").addClass('header-scroll')
        }
        // $('nav').css('backgroundColor', '#f8f7f3');
        // $('nav').removeClass('nav__text_color');
        hasDropdownState = 1;
    });

    $('.has-dropdown').on('mouseleave', function () {
        $('.mob-opacity').addClass('d-none');
        if (getYPosition() <= 0) {
            $("nav").removeClass('header-scroll')
        }
        // $("nav").css("backgroundColor", "rgba(255,255,255,0)");
        // $('nav').addClass('nav__text_color');
        hasDropdownState = 0;
    });

    function getYPosition() {
        var top = window.pageYOffset || document.documentElement.scrollTop;
        return top;
    }

    const $nav = $('nav')
    let prevPosition = 0
    if (window.innerWidth > 1023.98) {
        document.addEventListener('scroll', function () {
            const position = getYPosition()
            if(position <= 0 && !hasDropdownState) {
                $nav.removeClass('header-scroll').removeClass('header-hidden')
            } else if(prevPosition >= position) {
                $nav.addClass('header-scroll').removeClass('header-hidden')
            }  else if(prevPosition < position) {
                $nav.removeClass('header-scroll').addClass('header-hidden')
            }
            prevPosition = position
        })
    }

    // let scrollTopValue = getYPosition();
    // let navPos = setInterval(() => {
    //     scrollTopValue = getYPosition();
    //     if (scrollTopValue <= 0 && hasDropdownState != 1) {
    //         $("nav").css("backgroundColor", "rgba(255,255,255,0)");
    //         $('nav').addClass('nav__text_color');
    //         $('.account-dropdown__arrow').addClass('arrow-bottom-white');
    //     } else {
    //         $('nav').css('backgroundColor', '#f8f7f3');
    //         $('nav').removeClass('nav__text_color');
    //         $('.account-dropdown__arrow').removeClass('arrow-bottom-white');
    //     }
    // }, 2);

    // $('.pdp-carousel').owlCarousel({
    // 	loop: false,
    // 	center: true,
    // 	items: 1,
    // 	dots: true,
    // 	responsive: {
    // 		1024: {
    // 			nav: true,
    // 		},
    // 	},
    // });

    setTimeout(function () {
        const items = $('.pdp-carousel_item ');
        const dots = $('.item-images .owl-dot');

        for (let i = 0; i < items.length; i++) {
            // if ($(items[i]).attr("src")) {
            //     $(dots[i]).css("background", "url(" + $(items[i]).attr("src") + ")");
            // } else {
            //     $(dots[i]).css("background", "url(" + $(items[i]).attr("poster") + ")");
            //     $(dots[i]).addClass('video');
            // }
            // $(dots[i]).css("backgroundSize", "contain");
            // $(dots[i]).css("backgroundRepeat", "no-repeat");
            // $(dots[i]).css("backgroundPosition", "center");

            $(dots[i]).html($(items[i]).clone());
        }
    }, 200);

    var $photoItem = $('.photos-row .owl-item');
    var imgWidth = parseInt($photoItem.width()) + 2;
    let position = 0;
    var imgCount = $photoItem.length;
    var rowWidth = imgWidth * imgCount;
    var windowWidth = $('.photos-rail').width();
    var widthRange = rowWidth - windowWidth;

    $('.photos-rail_btn').on('click', () => {
        if (widthRange <= 0) {
            $('.photos-rail_btn').off('click');
            return;
        }
        widthRange -= imgWidth;
        position -= imgWidth;
        $('.photos-row').css('left', position);
    });

    $('.reviews-btn').on('click', function () {
        $('.review-modal').addClass('open');
    });

    $('.ingredients-btn').on('click', function (e) {
        e.preventDefault();
        $('.ingredients-modal').addClass('open');
    });

    $('.pdp-modal .close-btn').on('click', function () {
        $('.pdp-modal_wrapper').removeClass('open');
    });

    $('.pdp-modal_wrapper').on('click', function (e) {
        e.stopPropagation();
        if (!e.target.closest('.pdp-modal')) {
            $(this).removeClass('open');
        }
    });

    // js for account

    const accordionBtns = document.querySelectorAll('.profile-section_btn');
    const accorddionAction = document.querySelectorAll('.profile-section__action');
    const passResetBtn = document.querySelector('.profile-pass_edit');
    const passCancelBtn = document.querySelector('.pass-modal_cancel');
    const passResetModal = document.querySelector('.pass-modal');
    const profileSections = document.querySelectorAll('.profile-section');
    const profileDetails = document.querySelector('.profile-section.details');

    const isMobile = () => {
        return window.innerWidth < 1024;
    };

    if (accordionBtns) {
        accordionBtns.forEach((element) => {
            element.addEventListener('click', function(e){
                console.log(e.target.closest('.profile-section').classList.contains('active'))
                if(!e.target.closest('.profile-section').classList.contains('active')) {
                    profileSections.forEach((el) => el.classList.remove('active'));
                    e.target.closest('.profile-section').classList.add('active');
                }else {
                    e.target.closest('.profile-section').classList.remove('active');
                }

            });
        });
        if (passResetBtn) {
            passResetBtn.addEventListener('click', (e) => {
                e.preventDefault();
                passResetModal.classList.add('open');
                accordionBtns.forEach((el) => (el.style.display = 'none'));
                profileSections.forEach((el) => (el.style.display = 'none'));
                profileDetails.style.display = 'block';
            });
        }
        if (passCancelBtn) {
            passCancelBtn.addEventListener('click', (e) => {
                e.preventDefault();
                passResetModal.classList.remove('open');
                accordionBtns.forEach((el) => (el.style.display = 'block'));
                profileSections.forEach((el) => (el.style.display = 'block'));
            });
        }
    }

    if(accorddionAction) {
        accorddionAction.forEach(function(el, index) {
            $(el).on('click', function() {
                $(accordionBtns[index]).trigger('click')
            })
        })

    }

    const accountBtns = document.querySelectorAll('.account-tab-btn');
    const accountContent = document.querySelectorAll('.account-tab_content');
    const tabHeader = document.querySelector('.account-tab_header');

    if (accountBtns.length > 0) {
        if (isMobile()) {
            $(".account-tab-btn").on('click',function(e){
                e.stopPropagation();

                const isActive = $(this).closest(".account-tab_label").hasClass('active')
                $(".account-tab_label").removeClass("active");
                $(".account-tab_content").removeClass("active");
                if (isActive) {
                    $(this).closest(".account-tab_label").removeClass("active");
                    $(".account-tab_header").removeClass("account-tab_header--open");
                    $(e.target.dataset.tab).removeClass("active");
                } else {
                    $(this).closest(".account-tab_label").addClass("active");
                    $(".account-tab_header").addClass("account-tab_header--open");
                    $(e.target.dataset.tab).addClass("active");
                }
            })

        } else {
            const secondTab =
                window.location.href.match('tab=([^&]+)') && window.location.href.match('tab=([^&]+)')[1]
                    ? window.location.href.match('tab=([^&]+)')[1]
                    : null;
            if (secondTab === 'subscriptions') {
                window.location.href = '/tools/recurring/login/';
                return;
            }

            accountBtns.forEach((item) => {
                if (secondTab) {
                    if (item.dataset.tab === '#' + secondTab) {
                        item.classList.add('active');
                        item.closest('.account-tab_label').classList.add('active');
                        const currentContent = document.querySelector('#' + secondTab);
                        currentContent.classList.add('active');
                    }
                } else {
                    accountBtns.forEach((el) => el.closest('.account-tab_label').classList.remove('active'));
                    accountContent.forEach((el) => el.classList.remove('active'));
                    accountBtns[0].closest('.account-tab_label').classList.add('active');
                    accountContent[0].classList.add('active');
                }

                item.addEventListener('click', (e) => {
                    e.stopPropagation();
                    if (!e.target.dataset.tab) return;
                    accountBtns.forEach((el) => el.closest('.account-tab_label').classList.remove('active'));
                    e.target.closest('.account-tab_label').classList.toggle('active');
                    accountContent.forEach((el) => el.classList.remove('active'));
                    const currentContent = document.querySelector(e.target.dataset.tab);
                    currentContent.classList.add('active');

                    history.pushState({}, null, '/account?tab=' + e.target.dataset.tab.substring(1));
                });
            });
        }
    }

    var topBanner = $('.top-banner');
    $('.close-banner').click(function () {
        topBanner.addClass('d-none');
        $('nav').css('top', '0');
        $('.nav-mobile').css('top', '0');
    });

    window.addEventListener('scroll', bannerHeight);

    function bannerHeight() {
        if (window.pageYOffset > 36 || topBanner.hasClass('d-none') || topBanner.length === 0) {
            $('nav').css('top', '0');
            $('.nav-mobile').css('top', '0');
        } else {
            $('nav').css('top', '36px');
            $('.nav-mobile').css('top', '36px');
        }
    }

    if (topBanner.length === 0) {
        $('nav').css('top', '0');
        $('.nav-mobile').css('top', '0');
    }

    var element = $('.photos-rail'),
        elementOffset = element.offset() ? element.offset().top : 0,
        windowHeight = $(window).outerHeight() - element.outerHeight(),
        targetElement = $('.sticky-add-bag');

    $(window).on('scroll', function () {
        var getScrollPosition = $(window).scrollTop(),
            getBottomPosition = windowHeight + getScrollPosition;
        if (getBottomPosition >= elementOffset) {
            targetElement.addClass('sticky-add-bag--active');
        } else {
            targetElement.removeClass('sticky-add-bag--active');
        }
    });

	// $('.customize-set .set-wrapper .set-title').on('click', function () {
	// 	const isOpen = $(this).parent().hasClass('open');
	// 	$('.set-wrapper').removeClass('open');
	// 	if (!isOpen) {
	// 		$(this).parent().addClass('open');
	// 	}
	// });

});
